import { ApiResponse } from '@axilon-apps/libs-shared-api'
import { ToastMessageType } from '@axilon-apps/libs-ui-constants'
import { feedbackMessagesToastShow } from '@axilon-apps/libs-ui-components'

import { apiServiceInitiator } from '../instances'
import { refreshAuthenticationToken } from './refresh-authentication'
import type { BaseQuery, ApiExtraOptions, GenericErrorResponse, RequestParams } from './types'

const defaultExtraOptions: ApiExtraOptions = {
  public: false
}

const baseQuery =
  (): BaseQuery =>
  async (params, { dispatch }, extraOptions = defaultExtraOptions) => {
    const options = extraOptions as ApiExtraOptions
    const ApiService = apiServiceInitiator()

    if (!options.public) {
      const refresh = await refreshAuthenticationToken(dispatch)

      if (!refresh.ok) {
        return {
          error: refresh.error as GenericErrorResponse
        }
      }
    }

    const { body, ...rest } = params
    const requestParams: RequestParams =
      body !== undefined ? { ...rest, data: body } : (rest as RequestParams)

    try {
      const response = await ApiService.request(requestParams, options)

      return { data: response.data() }
    } catch (error) {
      const errorResponse = error as ApiResponse<unknown, unknown>

      if (errorResponse.isInternalServerError()) {
        dispatch(
          feedbackMessagesToastShow({
            type: ToastMessageType.Error,
            message:
              'An internal server error occured on the API Server, please notify the developers'
          })
        )
      }

      return {
        error: errorResponse.error()
      }
    }
  }

export default baseQuery
